<footer class="page-footer font-small pt-0 pb-0">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 text-center text-md-left">
        <div class="row">

          <div class="col-12 col-lg-3 pl-lg-3 py-3">
            <div class="row">
              <div class="col-12">
                <h6 class="mb-1 font-weight-bold">Horarios de atención</h6>
                <div class="line-break">{{ configuracion?.horarioAtencion }}</div>
                <div class="mt-4">
                  <mdb-icon fas icon="phone" size="2x" class="pie-color-icono mr-1"></mdb-icon>
                  <span class="h6">{{ configuracion?.telefonoContacto }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-lg-6 border-left-2px pl-lg-3 py-3 content-info-footer">
            <div class="row">
              <div class="col-lg-6 mb-auto">
                <div class="pb-3">
                  <h6 class="mb-1 font-weight-bold">Dirección</h6>
                  <div class="line-break">{{ configuracion?.direccion }}</div>
                </div>
              </div>
              <div *ngIf="configuracion.footerMap === 'google'" class="col-lg-6 pt-2 pb-2">
                <agm-map [latitude]="configuracion.ubicacionLatitud" [longitude]="configuracion.ubicacionLongitud"
                  [zoom]="zoom" style="height: 170px;" (mapClick)="placeMarker()">
                  <agm-marker [latitude]="configuracion.ubicacionLatitud"
                    [longitude]="configuracion.ubicacionLongitud"></agm-marker>
                </agm-map>
              </div>

              <div *ngIf="configuracion.footerMap === 'leaflet'" class="col-lg-6 pt-2 pb-2">
                <!-- Mapa de Leaflet -->
                <div id="map"></div>
              </div>
            </div>
          </div>

          <div class="col-12 col-lg-3 border-left-2px pl-lg-3 py-3 content-info-footer">
            <div class="row">
              <div class="col-12 text-center">
                <div>
                  <h6 class="mb-1 font-weight-bold">{{ configuracion?.mensajeRedesSociales }}</h6>
                </div>
                <div class="py-2">
                  <a href="javascript: void(0)" class="mx-3" [mdbTooltip]="'Facebook'"
                    [ngStyle]="!checkIconSocial('urlFacebook') ? {display: 'none'} : ''">
                    <mdb-icon fab icon="facebook-square" size="2x" class="pie-color-icono"
                      (click)="redirect(configuracion?.urlFacebook)"></mdb-icon>
                  </a>
                  <a href="javascript: void(0)" class="mx-3" [mdbTooltip]="'Twitter'"
                    [ngStyle]="!checkIconSocial('urlTwitter') ? {display: 'none'} : ''">
                    <mdb-icon fab icon="twitter-square" size="2x" class="pie-color-icono"
                      (click)="redirect(configuracion?.urlTwitter)"></mdb-icon>
                  </a>
                  <a href="javascript: void(0)" class="mx-3" [mdbTooltip]="'Instagram'"
                    [ngStyle]="!checkIconSocial('urlInstagram') ? {display: 'none'} : ''">
                    <mdb-icon fab icon="instagram" size="2x" class="pie-color-icono"
                      (click)="redirect(configuracion?.urlInstagram)"></mdb-icon>
                  </a>
                </div>
              </div>
              <div class="col-12 pl-4 pr-2 py-4 d-flex justify-content-center">
                <div class="row">
                  <div class="col-8">
                    <img height="60px" alt="" [src]="'data:image/jpg;base64,'+configuracion?.logoPieDePagina">
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid pie-fondo-color">
    <div class="container">
      <div class="row">
        <div class="col-lg-3 col-md-3 col-12 p-1">
          <div class="row">
            <p class="footer-letters m-auto">
              <i class="fa fa-copyright"></i>
              {{ configuracion?.mensajePiePagina }}
            </p>
          </div>
        </div>
        <div class="col-lg-9 col-md-9 col-12 p-1">
          <div class="row">
            <p class="footer-letters ml-auto link" *ngIf="configuracion?.urlProteccionDatos!=''"
              (click)="redirect(configuracion?.urlProteccionDatos)">
              Protección de datos
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>